import React from "react";
import Root from "./Components/Root";
import { Provider } from "react-redux";
import Store from "./Redux/Store";
import { ApolloProvider } from "@apollo/client";
import client from "./client";

export default () => (
  <Provider store={Store}>
    <ApolloProvider client={client}>
      <Root />
    </ApolloProvider>
  </Provider>
);
